import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-attempt-modal',
  templateUrl: './attempt-modal.component.html'
})
export class AttemptModalComponent implements OnInit {
  @Input() title: string;
  @Input() attempts: number;
  @Input() alertId: number;
  @Input() agents: string;
  @Input() message: string;
  @Input() userName: string;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  firstAgent: string = "";
  secondAgent: string = "";
  thirdAgent: string = "";
  agentNames: any;
  modalTimer: any = localStorage.getItem('modalTimer');
  interval: any;

  ngOnInit() {
    this.modalTimer = this.modalTimer == null ? 300000 : this.modalTimer;
    this.interval = setInterval(()=> { this.activeModal.close(false); clearInterval(this.interval) }, this.modalTimer)
    if(this.attempts > 1){
      this.agentNames = this.agents.split(',');
      this.firstAgent = this.agentNames[0] ? this.agentNames[0] : "";
      this.secondAgent = this.agentNames[1] ? this.agentNames[1] : "";
      this.thirdAgent = this.agentNames[2] ? this.agentNames[2] : "";
    }
    else if(this.attempts == 1){
      this.firstAgent = this.agents;
    }
  }
}
